export const EVENT_VIDEO_PLAY  = 'video:play';
export const EVENT_VIDEO_PAUSE = 'video:pause';
export const EVENT_VIDEO_ENDED = 'video:ended';
export const EVENT_VIDEO_ERROR = 'video:error';
export const EVENT_VIDEO_CLICK = 'video:click';
